import React, { FC } from 'react';
import Modal from 'react-modal';
import { BUILD_ALPHA, BUILD_BETA, BUILD_RELEASE_OFFICIAL, BUILD_SERVICE_PACK } from '../../constants/build-quality';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import closeIcon from '../../images/close.svg';
import ProductLogo from '../../images/Product.png';
import { useGlobalState } from '../../Providers';

interface AboutModalProps {
    isOpen: boolean;
    onClose: () => void;
    aboutModalButtonClick: (buttonClicked: string) => void
}

const AboutModal: FC<AboutModalProps> = ({ isOpen, onClose, aboutModalButtonClick }) => {
    const { translate } = useLocale();
    const { buildInfo } = useGlobalState() ?? {}; 

    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none overflow-hidden" >
        <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
            <div className="flex flex-row">
                <p className="pl-3 font-bold font text-white">{translate.byKey(TranslationKeys.about)} {buildInfo?.appNameFull}</p>
            </div>
            <img src={closeIcon} data-testid="modal_closeAbout" onClick={onClose} className="cursor-pointer mr-2" />
        </div>
        <div className="pb-3" style={{ width: '400px', }}>
            <div className='flex justify-center mt-3'>
                <img src={ProductLogo} alt='' style={{ maxHeight: '200px', width: '224px' }} />
            </div>
            <span className='flex text-sm justify-center font-bold pt-4'>
                {buildInfo?.buildQuality === BUILD_ALPHA ? translate.byKey(TranslationKeys.alpha) :
                    buildInfo?.buildQuality === BUILD_BETA ? translate.byKey(TranslationKeys.beta) :
                        buildInfo?.buildQuality === BUILD_SERVICE_PACK ? translate.byKey(TranslationKeys.servicePack) :
                            buildInfo?.buildQuality === BUILD_RELEASE_OFFICIAL ? translate.byKey(TranslationKeys.production) : "-----"} {buildInfo?.version}
            </span>
            <span className='flex text-sm justify-center'>{buildInfo?.licenseFullName}</span>
            <div className='flex justify-center'>
                <button
                    onClick={() => aboutModalButtonClick("copyright")}
                    data-testid="btn_copyright"
                    id='copyrightBtn'
                    className="text-white p-2 mt-3 mr-3 bg-sidemenu-focus rounded-lg">
                    {translate.byKey(TranslationKeys.copyright)}
                </button>
                <button
                    onClick={() => aboutModalButtonClick("license")}
                    data-testid="btn_license"
                    id='licenseBtn'
                    className="text-white p-2 mt-3 rounded-lg bg-sidemenu-focus">
                    {translate.byKey(TranslationKeys.license)}
                </button>
            </div>
        </div>
    </Modal>
}

export default AboutModal;
